import React from "react";
// import desktopImage from "../../assets/image/73ac9c4f85.jpg";
// import desktopImage from "../../assets/image/europe.png";
import desktopImage from "../../assets/image/بانر.png";


// import desktopImage from "../../assets/image/Hero section website.png";
// import mobileImage from "../../assets/image/73ac9c4f85.jpg";
import { Link } from "react-router-dom";
import "./Mainbanner.css";
import Servs from "../../components/Servs/Servs";
// import Desten from "../../components/Desten/Desten";
import Video from "../../components/Video/Video";
import CustSaying from "../../components/CustSaying/CustSaying";
import LastSec from "../../components/LastSec/LastSec";
// import TravSides from "../../components/TravSides/TravSides";

export default function Mainbanner() {
  return (
    <>
      <section className="hero-section text-white" role="banner" aria-label="التنظيم للسفر والسياحة">
        {/* صورة الخلفية – موبايل ثم ديسكتوب */}
        <picture>
          <source media="(max-width: 768px)" srcSet={desktopImage} />
          <img
            src={desktopImage}
            alt="خلفية سفر وسياحة"
            className="hero-img"
            loading="eager"
            decoding="async"
          />
          
        </picture>

        {/* Overlay + المحتوى */}
        <div className="hero-overlay">
          <div className="hero-content container">
            <h1 className="hero-title">التنظيم</h1>
            <h2 className="hero-subtitle">للسفر والسياحة</h2>
            <p className="hero-text">
              نقدم العديد من المزايا والخدمات التي تجعل السفر أكثر راحة وسهولة للعملاء
            </p>

            <Link
              to="/contact"
              className="btn btn-danger btn-lg contactBtn"
              aria-label="اطلب الخدمة الآن"
            >
              طلب الخدمة
            </Link>
          </div>
        </div>
      </section>

      <Servs />
       {/*<Desten /> 
      <TravSides />*/}


      <Video />
      <CustSaying />
      <LastSec />
    </>
  );
}
